export default __webpack_public_path__ + "static/002-2ef835c259bee2594eb070c785f3029a.png";